<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>建群</h1>
        <span class="pull-right icon-right orange" @click="saveOrUpdateClass()">确定</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page">
      <div>
        <p class="margin-15">红色“*”为必填项，请认真填写。</p>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">群名称：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入群名称" v-model="className"></span>
            </div>
          </li>
          <li class="list-group" @click.prevent="showSelectTeacher()">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" href="javascript:;">
              <span class="pull-left">编入老师：</span><i class="red must">*</i>
              <span class="pull-right gray margin-x-15">
                <template v-for="item in teacherSelectList">
                  {{item.teacherName}}&nbsp;
                </template>
              </span>
            </a>
          </li>
          <li class="list-group" @click.prevent="showSelectStudent()">
            <div class="liner"></div>
              <a class="clearfix group-txt img-more" href="javascript:;">
              <span class="pull-left">编入学生：</span><i class="red must">*</i>
              <span class="pull-right gray margin-x-15">{{studentSelectList.length}}人</span>
            </a>
          </li>
        </ul>

        <ul class="list-group-item primary">
          <li class="list-group" v-for="item in studentSelectList">
            <div class="liner"></div>
            <router-link class="group-link clearfix"  :to="{path:'/student/detail/' + item.studentId}">
              <span class="img-wrap small pull-left">
              <img class="pull-left" :src="item.imageAddress ? item.baseAcessPath + item.imageAddress : img_default" width="40" height="40"/>
              </span>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="pull-left">{{item.studentName}}</cite><i class="img-sex boy">男</i>
                  <cite class="gray pull-right" v-if="item.typeName">{{item.typeName}}</cite>
                  <cite class="orange pull-right" v-else>未添加托管服务</cite>
                </span>
              </span>
            </router-link>
          </li>
        </ul>

      </div>
    </div>

    <div class="maskdiv" v-show="!isHideGoAddStudent" @click="isHideGoAddStudent = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p>该班级还没有录入过学生信息，是否现在去添加学生？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><router-link class="blue  block" style="border-right:1px solid #ddd;" :to="{'path': '/student/add'}">去添加</router-link></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideGoAddStudent = true">以后再说</a></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <div class="maskdiv" v-show="!isHideSelectTeacher" @click="isHideSelectTeacher = true">
      <div class="slider" @click.stop>
        <strong class="tit">关联老师</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in teacherList">
            <li @click.stop="item.isChecked = !item.isChecked">
              <div class="clearfix group-link"><span class="pull-left">{{item.teacherName}}</span>
                <i class="pull-right img-checkbox" v-bind:class="{'checked': item.isChecked}" ></i>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
        <div class="text-center"><a class="button button-rounded button-line" @click.prevent="isHideSelectTeacher = true">确定</a></div>
      </div>
    </div>
  <div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      get_curche_teacher_para: service.setPara('getCurcheTeacher'),
      save_or_update_class_para: service.setPara('saveOrUpdateClass'),
      studentList: [],
      studentSelectList: [],
      teacherList: [],
      teacherSelectList: [],
      className: '',
      curcheId: 0,
      isHideSelectStudent: true,
      isHideGoAddStudent: true,
      isHideSelectTeacher: true,
      isGetTeacherList: false,
      isGetStudentList: false
    }
  },
  components: {
    dialogStudents
  },
  computed: {
    ...mapGetters({
      studentListX: 'getStudentsByFirstChar',
      teacherListX: 'teacherList'
    }),
    teacherSelectList: function () {
      let list = []
      for (let i = 0; i < this.teacherList.length; i++) {
        if (this.teacherList[i].isChecked) {
          list.push(this.teacherList[i])
        }
      }
      return list
    },
    studentSelectList: function () {
      let list = []
      for (let i = 0; i < this.studentList.length; i++) {
        for (var j = 0; j < this.studentList[i].students.length; j++) {
          if (this.studentList[i].students[j].isChecked) {
            list.push(this.studentList[i].students[j])
          }
        }
        // if (this.studentList[i].isChecked) {
        //   list.push(this.studentList[i])
        // }
      }
      return list
    }
  },
  mounted: function () {
    this.curcheId = this.cookie_login_data.curcheId

    // 获取园点学生数据
    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.get_new_student_list_para.context = this
    this.$store.dispatch('receiveStudents', this.get_new_student_list_para)

    // 获取园点老师数据
    this.get_curche_teacher_para.curcheId = this.curcheId
    this.get_curche_teacher_para.context = this
    this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'receiveTeachers',
      'clearClass'
    ]),
    // 添加班级
    saveOrUpdateClass: function () {
      if ($.trim(this.className) == '') {
        Toast('请填写群名称')
        return
      }

      if (this.studentSelectList.length == 0) {
        Toast('至少选择一位学生')
        return
      }

      this.save_or_update_class_para.className = this.className
      this.save_or_update_class_para.curcheId = this.cookie_login_data.curcheId

      this.save_or_update_class_para.studentIdList = []
      for (var i = 0; i < this.studentSelectList.length; i++) {
        this.save_or_update_class_para.studentIdList.push(this.studentSelectList[i].studentId)
      }
      this.save_or_update_class_para.teacherIdList = []
      for (let i = 0; i < this.teacherSelectList.length; i++) {
        this.save_or_update_class_para.teacherIdList.push(this.teacherSelectList[i].teacherId)
      }

      let obj = {context: this, para: this.save_or_update_class_para, successFun: (response) => {
        Toast('添加成功')
        this.$store.dispatch('clearClass')
        window.history.go(-1)
      }}
      service.request(obj)
    },
     // 显示编入学生
    showSelectStudent: function () {
      if (this.isGetStudentList > 0) { // 已经有关联学生数据
        this.isHideSelectStudent = false
        return
      }

      let jsonStr = JSON.stringify(this.studentListX)
      let list = JSON.parse(jsonStr)
      // for (var i = 0; i < list.length; i++) {
      //   list[i].isChecked = false
      // }
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].students.length; j++) {
          list[i].students[j].isChecked = false
        }
      }
      this.studentList = list
      this.isGetStudentList = true
      var jobCode = this.login_data[this.cookie_login_data.index].jobCode
      var yesNo = this.login_data[this.cookie_login_data.index].yesNo
      if ((jobCode === 'leader' || jobCode === 'dudao') && yesNo === 1) {
        if (this.studentList.length === 0) {
          this.isHideGoAddStudent = false
        } else {
          this.isHideSelectStudent = false
        }
      }
    },
    // 显示关联老师
    showSelectTeacher: function () {
      if (this.isGetTeacherList > 0) { // 已经有关联老师数据
        this.isHideSelectTeacher = false
        return
      }

      let jsonStr = JSON.stringify(this.teacherListX)
      let list = JSON.parse(jsonStr)
      for (var i = 0; i < list.length; i++) {
        list[i].isChecked = false
      }
      this.teacherList = list
      this.isHideSelectTeacher = false
      this.isGetTeacherList = true
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      student.isChecked = !student.isChecked
    }
  }
}
</script>
<style scoped>
  .mint-indexlist-content{padding-right:32px;}
</style>


// WEBPACK FOOTER //
// ClassAdd.vue?6f7e7e8e